import { Controller } from "@hotwired/stimulus"
import { HIDDEN_SECTION } from "../src/toggle_section_visibility"

export default class extends Controller {
  static values = { entry: String, cvRecordType: String, newRecordOnChange: Boolean, resetEntryOnly: Boolean,
    clearHiddenSections: Boolean }

  // The form is rendered again to edit a record, so this is its entry value.
  connect() {
    this.editedEntry = this.entryField?.value
    this.syncTranslationSwitch()
    this.openIncompleteCvRecord()
  }

  prepopulate(event) {
    if (!event.target.contains(this.element)) return

    this.clear()
    this.openIncompleteCvRecord()
  }

  changed(event) {
    if (event.target !== this.entryField) return

    this.syncTranslationSwitch()
    if (this.clearHiddenSectionsValue) {
      this.element.querySelectorAll(HIDDEN_SECTION).forEach((section) => this.clearFields(section))
    }
    if (this.newRecordOnChangeValue && this.recordField?.value && event.target.value !== this.editedEntry) {
      this.recordField.value = ""
    }
  }

  clear() {
    if (this.resetEntryOnlyValue) return this.reset(this.entryField, "")

    this.clearFields(this.element)
  }

  clearFields(root) {
    root.querySelectorAll(window.mdFormHelper.selectors.text).forEach((field) => this.reset(field, ""))
    root.querySelectorAll(window.mdFormHelper.selectors.select).forEach((select) => {
      this.reset(select, select.options[0]?.value ?? "")
    })
  }

  reset(field, value) {
    field.value = value
    field.dispatchEvent(new Event("change", { bubbles: true }))
  }

  openIncompleteCvRecord() {
    if (!this.hasCvRecordTypeValue || this.entryField?.value) return
    if (!this.element.closest(".registration-section")?.classList.contains("active")) return

    document.querySelector(
      `[data-record-type='${this.cvRecordTypeValue}'] [data-record-has-errors='true'] .edit-btn`
    )?.click()
  }

  syncTranslationSwitch() {
    this.element.querySelector(".toggle-translate")?.classList.toggle("tw-hidden", !this.entryField?.value)
  }

  get entryField() {
    return this.element.querySelector(this.entryValue)
  }

  get recordField() {
    return this.element.querySelector("#record_id")
  }
}
